<template>
  <div :class="{ more_btn_box: showMoreBtn }">
    <ul class="operate_ul">
      <li
        v-for="(item, index) in moreBtnArr"
        :key="index"
        @click="btnFn(item.methodName)"
        class="operate_btn"
      >{{ item.name }}</li>
    </ul>
<!--    <div class="operate_btn" v-show="!showMoreBtn">更多操作</div>-->
    <el-dialog
      :visible.sync="showPrompt"
      width="550px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <el-tabs v-model="promptActiveName">
          <el-tab-pane label="设置提醒" name="first">
            <div class="demo-dynamic">
              <!-- {{rowData.ebqUserName}} -->
              <div style="margin-bottom: 10px">注：系统将提示短信发送至接收手机；提示内容：您在君子签电子签约平台签署的合同即将到期,请及时查看</div>
              <el-form :model="promptFrm" ref="promptFrm" label-width="100px">
                <template v-for="(item, index) in promptFrm.promptList">
                  <el-row :key="index">
                    <el-col :span="11">
                      <el-form-item
                        :prop="'promptList.' + index + '.mobile'"
                        label-width="0px"
                        :rules="[
                    {
                      validator: $validator.regex,
                      regex: /^1\d{10}$/,
                      message: '请输入正确手机号',
                      trigger: 'change',
                    },
                  ]"
                      >
                        <el-input
                          v-model="item.mobile"
                          type="text"
                          :placeholder="'请输入手机号'"
                          :disabled="item.remote"
                          style="width: 220px; margin-right: 10px"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item
                        :prop="'promptList.' + index + '.promptTime'"
                        label-width="0px"
                        :rules="[
                    {
                      required: true,
                      message: '请选择提醒日期',
                      trigger: 'blur',
                    },
                  ]"
                      >
                        <el-date-picker
                          popper-class="date-popper-cls"
                          value-format="yyyy-MM-dd"
                          align="left"
                          :picker-options="promptTimePkOption"
                          v-model="item.promptTime"
                          type="date"
                          :disabled="item.remote"
                          :placeholder="'请选择提醒日期'"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="2" v-if="promptFrm.promptList.length > 1 && !item.remote">
                      <span
                        @click="promptFrm.promptList.splice(index, 1)"
                        style="font-size: 26px; color: #ec1c1c"
                      >
                        <i class="el-icon-close"></i>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="分享他人" name="second">
            <el-form ref="receiveFormRef" :model="receiveObj" class="service_ul">
              <p>链接有效期：</p>
              <el-form-item
                prop="validityPeriod"
                :rules="[
                  { required: true, message: '请选择有效期', trigger: 'blur' },
                ]"
              >
                <el-select
                  v-model="receiveObj.validityPeriod"
                  placeholder="请选择链接有效期"
                  size="medium"
                  style="width: 90%"
                >
                  <el-option label="3天" :value="3"></el-option>
                  <el-option label="5天" :value="5"></el-option>
                  <el-option label="7天" :value="7"></el-option>
                </el-select>
              </el-form-item>
              <p>接收人信息：</p>
              <el-form-item v-for="(item, index) in receiveObj.receiveArr" :key="'receive' + index">
                <li class="service_li">
                  <el-input
                    style="width: 37%; margin-right: 2%"
                    disabled
                    :value="item.mobile"
                    size="small"
                  ></el-input>
                  <el-input
                    style="width: 37%; margin-right: 2%"
                    disabled
                    :value="item.createTime.split(' ')[0] + '送达分享'"
                    size="small"
                  ></el-input>
                  <div
                    style="width: 12%"
                    :class="['tip_text', {'tip_text1': item.status === 2}]"
                  >{{item.status === 1 ? '已分享' : '已查看'}}</div>
                </li>
              </el-form-item>
              <p>添加接收人：</p>
              <el-form-item
                v-for="(item, index) in receiveObj.addReceiveArr"
                :prop="'addReceiveArr.' + index + '.value'"
                :rules="[{  validator: $validator.mobile, trigger: 'blur'}]"
                :key="'add' + index"
              >
                <li class="service_li">
                  <el-input
                    style="width: 90%"
                    type="number"
                    placeholder="请输入接收人手机号码"
                    maxlength="11"
                    minlength="11"
                    v-model.trim="item.value"
                    size="small"
                  ></el-input>
                  <div class="operation_btn">
                    <!--                    <div class="add_btn" @click="addReceiveFn">+</div>-->
                    <i
                      v-if="receiveObj.addReceiveArr.length > 1"
                      class="el-icon-delete"
                      style="font-size: 26px; cursor: pointer; color: #a0a0a0;"
                      @click="deleteReceiveArrFn(index)"
                    ></i>
                  </div>
                </li>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center; margin-top: 40px">
        <template v-if="promptActiveName === 'first'">
          <el-button
            @click="promptFrm.promptList.push({ mobile: '', promptTime: '' })"
            size="small"
            type="danger"
            style="width: 120px"
          >添加</el-button>
          <el-button
            @click="promptOrder()"
            size="small"
            type="danger"
            style="width: 120px;margin-left:10px"
          >确认提交</el-button>
        </template>
        <template v-else>
          <el-button @click="addReceiveFn" size="small" type="danger" style="width: 120px">添加</el-button>
          <el-button
            @click="addReceiveSubmit()"
            size="small"
            type="danger"
            style="width: 120px;margin-left:10px"
          >确认提交</el-button>
        </template>
      </div>
    </el-dialog>
    <!-- 选择框   -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="sSDialogVisible"
      title="请选择主体身份"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="sSDialogArr && sSDialogArr.length > 0" style="padding: 10px 20px">
        <template v-for="(item, index) in sSDialogArr">
          <div :key="index">
            <el-radio v-model="choosedCert" :label="index">
              {{
              item.signatoryFullName || item.idenName
              }}
            </el-radio>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="sSDialogVisible = false">取消</el-button>
        <el-button
          id="tag-copy1"
          :data-clipboard-text="vpresId"
          @click="onSelectCret(sSDialogArr[choosedCert])"
          size="small"
          type="danger"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods, applyViewUrl } from "@/assets/js/http-serve/corp/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import GlobalConfig from "../../assets/js/config/global";
import { gantConf, getPermInfo } from "@/assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
export default {
  name: "more-buttton",
  props: {
    hideArbitrate: {
      type: Boolean,
      default: false,
    },
    //在成员的列表中使用/I接口请求，本来是/C，特殊处理(企业主体合同)
    enterpriseSubjectType: {
      type: [Number, String],
      default: 4, //本来是0，但是0要用于判断企业中查看成员合同
    },
    //显示 超出/未超出 的按钮
    showMoreBtn: {
      type: Boolean,
      default: false
    },
    // 是否可以不拥有合同作废权限也可作废合同
    Cancancel: {
      type: Boolean,
      default: false
    },
    //数据
    rowData: {
      type: Object
    },
  },
  data () {
    return {
      //文件送达
      promptActiveName: 'first',

      receiveObj: {
        validityPeriod: 3,
        addReceiveArr: [{ value: '' }],
        receiveArr: [],
      },
      applyArbitration: false, //是否是申请仲裁
      moreBtnArr: [],
      isChild: "",
      //  提醒
      promptFrm: { promptList: [{ mobile: "", promptTime: "" }] },
      showPrompt: false,
      // 到期提醒时间输入限制必须大于今天
      promptTimePkOption: {
        disabledDate (time) {
          return time.getTime() < Date.now();
        }
      },
      //  弹窗
      sSDialogArr: [], //窗口列表
      sSDialogVisible: false,
      choosedCert: 0,
      vpresId: ""
    };
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    userType () {
      return this.$store.getters.currentAuthUser.superFlag == 0 ||
        this.$store.getters.currentAuthUser.superFlag == 1
        ? 1
        : 0;
    },
    currentIsCorpUser () {
      if (
        (this.$store.getters.currentAuthUser || {}).hasOwnProperty("superFlag")
      ) {
        return true;
      }
      return false;
    }
  },
  mounted () {
    const v = sessionStorage.getItem("ISCHILD");
    if (v === "true") {
      this.isChild = true;
    }
    this.init();
  },
  methods: {
    init () {
      const { applySignCreateType, applySignDealType, terminationApplyNo } = this.rowData;
      let createType = this.rowData['createType'] !== undefined ? 'createType' : 'applySignCreateType';
      // this.$route.path === "/signInfo/signList"
      //   ? "applySignCreateType"
      //   : "createType";
      let applySignStatus = this.rowData['signStatus'] !== undefined ? 'signStatus' : 'applySignStatus';
      // this.$route.path === "/signInfo/signList"
      //   ? "applySignStatus"
      //   : "signStatus";
      const applyStatus = this.rowData[applySignStatus]
      if (![-3, -4].includes(applyStatus)) {
        switch (applyStatus) {
          case 1:
            // 24-6-20；产品说隐藏
            // this.moreBtnArr.push({
            //   name: "出证",
            //   methodName: "certificationFn"
            // });
            this.moreBtnArr.push({ name: "上传履约文件", methodName: "openLYDialog" });
            if (!this.hideArbitrate) {
              this.moreBtnArr.push({ name: "申请仲裁", methodName: "applicationArbitrationFn" });
            }
            if (this.rowData[createType] === 1 && this.$store.getters.hasAuthUser) {
              this.moreBtnArr.push({ name: "防伪打印", methodName: "goPrintFn" });
            }
            // applySignCreateType === 0且applySignDealType === 6的时候，不显示送达和证据包下载 2个按钮，测试说的
            if (!this.isChild && !(applySignCreateType === 0 && applySignDealType === 6)) {
              this.moreBtnArr.push({ name: "提醒/分享", methodName: "toShowPrompt" });
            }
            if (applySignCreateType !== 0 && this.Cancancel) {
              const cancelBtn = terminationApplyNo ? { name: "查看作废协议", methodName: "handleInsurance" } : { name: "合同作废", methodName: "invalidation" };
              this.moreBtnArr.unshift(cancelBtn);
            }
            break;
          case 4:
            this.moreBtnArr.unshift({ name: "查看作废协议", methodName: "handleInsurance" })
            break;
          default:
            break;
        }
        if (!(applySignCreateType === 0 && applySignDealType === 6)) {
          this.moreBtnArr.push({ name: "证据包下载", methodName: "batchDown" });
        }
      }
    },
    btnFn (methodName) {
      if (methodName === "openLYDialog") {
        this.$emit("btnMethodFn", this.rowData);
      } else {
        this[methodName]();
      }
    },
    // 查看作废协议（合同作废发起使用的是pc多文件发起，默认走多文件查看页面）
    handleInsurance () {
      const { signNo, applySignCreateType, applySignDealType, terminationApplyNo } = this.rowData;
      if (applySignCreateType === 0 && applySignDealType === 6) return this.$message.error('该合同仅是hash保全，无法查看合同内容');
      let param = { signNo, applyNo: terminationApplyNo, multiFile: 1 }, path = '/applySign/toDetailMultiAnony';
      this.loading = this.$loading({ lock: true });
      const isCorp = this.currentAuthUser.corpUserId;
      if ([1, 2, 3].includes(this.enterpriseSubjectType) || !isCorp) {
        ApiMethods.UserApplySignController.viewUrl({
          ...param,
          corpQuery: 1,
        }).then(({ data }) => {
          this.loading.close();
          data.approveId = '';
          let router = this.$router.resolve({ path, query: data });
          let href = window.location.origin + router.href;
          // 如果是钉钉环境就走 location 不要 window.open
          isInDingTalk ? location.href = href : window.open(href);
        })
          .catch(err => {
            this.loading.close();
            this.$message.error(err.description || "无法查看该合同");
            console.error("toApplyDetail: " + JSON.stringify(err));
          });
      } else {
        applyViewUrl(param)
          .then(url => {
            this.loading.close();
            isInDingTalk ? this.$router.push(url) : window.open(url);
          })
          .catch(err => {
            this.loading.close();
            this.$message.error(err.description || "无法查看该合同");
            console.error("toApplyDetail: " + JSON.stringify(err));
          });
      }
    },
    /** 合同作废 */
    invalidation () {
      console.log('rowData', this.rowData);
      const { applySignCreateType: TYPE, terminationApplyNo } = this.rowData;
      if (terminationApplyNo) return this.$message.warning('已发起合同作废，请勿重复操作')
      if (TYPE === 0) return this.$message.warning("API合同不支持作废")
      /** 权限验证 */
      const perms = this.perms, KEY = gantConf.invalidation;
      const bool = perms.includes(KEY), isCorp = this.currentAuthUser.corpUserId;
      if ((!bool && isCorp) && !this.Cancancel) {
        const Pinfo = getPermInfo(KEY)
        return this.$message.warning(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      // 暂存合同信息
      sessionStorage.setItem('NeedToBeInvalidated', JSON.stringify(this.rowData))
      // 跳转到合同作废页面
      const path = '/initiation/invalidation/cancellation';
      isInDingTalk ? this.$router.push({ path }) : window.open(`${GlobalConfig.domain.junziqianWebOp}${path}`, '_blank')
    },
    //  获取送达人
    async getReceiveListFn () {
      let res = '';
      if (this.$store.getters.currentAuthUser.corpUserId) {
        res = await ApiCorpMethods.ContractController.corpViewUrl({ applyNo: this.rowData.applyNo });
        res = await ApiCorpMethods.CorpCommonController.corpReceiveList(res.data)
      } else {
        res = await ApiMethods.UserApplySignController.viewUrl({ applyNo: this.rowData.applyNo });
        res = await ApiMethods.UserTagController.receiveList(res.data)
      }
      this.receiveObj.receiveArr = res.data;
    },
    //添加送达人
    addReceiveFn () {
      this.receiveObj.addReceiveArr.push({ value: '' });
    },
    //删除送达人
    deleteReceiveArrFn (index) {
      this.receiveObj.addReceiveArr.splice(index, 1);
    },
    //送达人接口提交
    addReceiveSubmit () {
      this.$refs.receiveFormRef.validate((valid) => {
        if (valid) {
          this.payOrderFn();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //支付订单
    async payOrderFn (type) {
      let res = '';
      let arr = this.receiveObj.addReceiveArr.map((item) => {
        return {
          mobile: item.value,
          time: this.receiveObj.validityPeriod,
        }
      })
      if (this.$store.getters.currentAuthUser.corpUserId) {
        res = await ApiCorpMethods.ContractController.corpViewUrl({ applyNo: this.rowData.applyNo });
        res = await ApiCorpMethods.CorpCommonController.corpAddReceive({
          ...res.data,
          promptJson: JSON.stringify(arr),
          pay: type ? 1 : 0,
        })
      } else {
        res = await ApiMethods.UserApplySignController.viewUrl({ applyNo: this.rowData.applyNo });
        res = await ApiMethods.UserTagController.addReceive({
          ...res.data,
          promptJson: JSON.stringify(arr),
          pay: type ? 1 : 0,
        })
      }
      if (res.data.recharge) {
        this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
      } else if (res.data.needPay) {
        this.$confirm(
          `需消耗${res.data.point}积分。`,
          "支付提示",
          {
            showConfirmButton: true,
            showCancelButton: true,
            type: "info"
          }
        ).then(res => {
          this.payOrderFn('needPay')
        })
      } else {
        this.$message.success('操作成功')
        this.receiveObj = {
          validityPeriod: 3,
          addReceiveArr: [{ value: '' }],
          receiveArr: [],
        };
        this.showPrompt = false;
      }
    },
    //申请仲裁
    applicationArbitrationFn () {
      this.certificationFn(true)
    },
    //出证
    async certificationFn (applyArbitration = false) {
      this.applyArbitration = applyArbitration;
      let _this = this;
      let _param = {
        signNo: this.rowData.signInfoNo || "",
        applyNo: this.rowData.applyNo || ""
      };
      if (!_param.ts || !_param.sign) {
        let viewUrlParam = { signNo: _param.signNo, applyNo: _param.applyNo };
        if ([1, 2, 3].includes(this.enterpriseSubjectType)) {
          viewUrlParam.corpQuery = 1;
        }
        let viewUrlRes;

        // 接口调用重构 start
        // author：yf
        // time：20210204
        if (this.$route.path.indexOf("console") > -1) {
          //corpViewUrl  ----
          // 控制台里面调用/c/m
          viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
            viewUrlParam
          );
        } else {
          // 工作台里面分（个人企业调用/i）和（集团调用/c）
          if (!this.currentIsCorpUser && ![1, 2, 3].includes(this.enterpriseSubjectType)) {
            // 个人或者企业
            if (this.enterpriseSubjectType === 0) {
              viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
                viewUrlParam
              );
            } else {
              viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
                viewUrlParam
              );
            }
          } else {
            // 集团
            // viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
            // viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
            if (this.$store.getters.currentAuthUser.corpUserId) {
              viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
                viewUrlParam
              );
            } else {
              viewUrlRes = await ApiCorpMethods.ContractController.corpViewUrl(
                viewUrlParam
              );
            }

          }
        }
        // 接口调用重构 end

        if (!viewUrlRes.success) {
          return _this.$message.error(
            viewUrlRes.description || "初始化数据失败"
          );
        }
        _param = viewUrlRes.data;
      }
      if (
        this.$store.getters.currentAuthUser &&
        this.$store.getters.currentAuthUser.corpUserId
      ) {
        _param.corpUserId = this.$store.getters.currentAuthUser.corpUserId;
      }
      let certiListRes = await ApiMethods.ApplySignController.certiList(_param);
      if (certiListRes.success) {
        if (!certiListRes.data || certiListRes.data.lengt == 0)
          return _this.$message.error("初始化数据失败");
        if (certiListRes.data.length === 1) {
          let _data = { ...certiListRes.data[0] };
          return _this.gotoRedirectTesity(_data);
        }
        if (certiListRes.data.length > 1) {
          this.sSDialogArr = certiListRes.data;
          this.sSDialogVisible = true;
        }
      } else {
        _this.$message.error(certiListRes.description);
      }
    },
    async gotoRedirectTesity (data) {
      //非大陆的账户不能去出证
      if ([2, 3, 4].includes(data.identityType)) {
        return this.$message.error(
          "该主体个人实名认证为港澳台/护照证件，无法申请出证。"
        );
      }
      console.log("gotoRedirectTesity参数打印", data);
      // newUrl 0 旧业面 1 新页面
      let _this = this,
        ow = null;
      if (!isInDingTalk) ow = window.open("about:blank");
      if (
        this.$store.getters.currentAuthUser &&
        this.$store.getters.currentAuthUser.corpUserId
      ) {
        data.corpUserId = this.$store.getters.currentAuthUser.corpUserId;
      }
      let redirectTesityRes = '';
      //申请仲裁
      if (this.applyArbitration) {
        data.backUrl = GlobalConfig.domain.junziqianWebOp + '/judicialService/applyArbitration';
        redirectTesityRes = await ApiMethods.CertiController.redirectToArb(
          data
        );
      } else { //申请出证
        redirectTesityRes = await ApiMethods.CertiController.redirectTesity(
          data
        );
      }
      if (redirectTesityRes.success) {
        if (!isInDingTalk) {
          ow.location.href = redirectTesityRes.data;
        } else {
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = redirectTesityRes.data;
          document.body.append(a);
          a.click();
          setTimeout(() => {
            a.remove();
          }, 1000);
        }
      } else {
        _this.$message.error(redirectTesityRes.description || this.$tip);
        ow.close();
      }
    },
    //确定
    onSelectCret (data) {
      this.sSDialogVisible = false;
      if (this.dialogType === "copy") {
        this.vpresId = (data.videncePresId || data.presId)
          .toString()
          .padStart(10, "0");
        this.copyFn("tag-copy1");
      } else {
        this.gotoRedirectTesity(data);
      }
    },
    //设置提醒数据
    toShowPrompt: function () {
      var _this = this;
      var param = {
        signNo: this.rowData.signInfoNo,
        applyNo: this.rowData.applyNo
      };
      //获取提醒列表
      ApiMethods.SendSms4SignController.promptList(param).then(result => {
        if (result.success) {
          if (result.data && result.data.length > 0) {
            _this.promptFrm.promptList = result.data.map(i => {
              i.remote = true;
              return i;
            });
          }
        } else {
          _this.$message.error(result.description || this.$tip);
        }
      });
      this.getReceiveListFn() //获取送达列表
      this.showPrompt = true;
    },
    //  提交提醒
    promptOrder: function () {
      var _this = this;
      if (_this.promptFrm.promptList.length < 1) {
        return _this.$message.error("提交数据不能为空");
      }
      _this.$refs.promptFrm.validate(valid => {
        if (valid) {
          // var newWindow = window.open();
          var param = {
            signNo: this.rowData.signInfoNo,
            applyNo: this.rowData.applyNo
          };
          param.promptJson = JSON.stringify(
            _this.promptFrm.promptList.filter(i => !i.remote)
          );
          param.returnURL = window.location.href;
          ApiMethods.SendSms4SignController.promptOrder(param).then(result => {
            if (!result.success)
              return _this.$message.error(result.description || "操作失败");
            if (result.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `本次提醒需消耗${result.data.point}积分`,
                "支付提示",
                {
                  showConfirmButton: true,
                  showCancelButton: true,
                  type: "info"
                }
              ).then(() => {
                ApiMethods.SendSms4SignController.promptOrder(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) {
                    this.toShowPrompt();
                    return this.$message.success("提交成功");
                  }
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          });
        }
      });
    },
    //  下载
    batchDown () {
      if (this.rowData.videnceFile) {
        this.downloadFile({ ...this.rowData.videnceFile });
      } else {
        this.$message.error('证据包暂未生成！')
      }
      return false;
      if (this.$route.path === "signInfo/signList") {
        ApiMethods.UseEnterpriseController.downloadBatch({
          applyNos: this.rowData.applyNo
        })
          .then(res => {
            if (!res.success)
              return this.$message.error(res.description || this.$tip);
            this.downloadFile(res.data);
          })
          .finally(() => { });
      } else {
        let param = {
          applyNos: this.rowData.applyNo
        };
        if (this.$store.getters.currentAuthUser.userType === 0) {
          ApiMethods.UseEnterpriseController.downloadBatch(param)
            .then(res => {
              if (!res.success)
                return this.$message.error(res.description || this.$tip);
              this.downloadFile(res.data);
            })
            .finally(() => { });
        } else {
          ApiCorpMethods.CorpApplyContractController.downloadBatch(param)
            .then(res => {
              if (!res.success)
                return this.$message.error(res.description || this.$tip);
              this.downloadFile(res.data);
            })
            .finally(() => { });
        }
      }
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        // window.location.href = res.url;
        let elink = document.createElement('a');
        elink.download = param.targetId;
        elink.style.display = 'none';
        elink.href = res.url;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } else {
        this.$message.error(res.err);
      }
    },
    //下一步
    nextViewUrlFn (res) {
      if (!res.success) {
        return this.$message.error(
          res.description || "初始化数据失败"
        );
      }
      let k = {
        ...this.$route.query,
        ...res.data
      };
      this.$router.push({ path: this.$route.path, query: k });
      if (this.rowData.multiFile) {
        this.goMultiFilePrint(res.data);
      } else {
        this.goPrint(res.data);
      }
    },
    //  goPrint
    goPrintFn () {
      if (
        ["/corp/signInfo/signList", "/corp/signInfo/applyList"].includes(
          this.$route.path
        )
      ) {
        if (this.$store.getters.currentAuthUser.corpUserId) {
          ApiCorpMethods.ContractController.viewUrl({
            applyNo: this.rowData.applyNo
          }).then(res => {
            this.nextViewUrlFn(res);
          });
        } else {
          ApiCorpMethods.UserSignController.viewUrl({
            applyNo: this.rowData.applyNo
          }).then(res => {
            this.nextViewUrlFn(res);
          });
        }
      } else {
        if (this.enterpriseSubjectType === 0) {
          ApiCorpMethods.ContractController.viewUrl({
            applyNo: this.rowData.applyNo
          }).then(res => {
            this.nextViewUrlFn(res);
          });
        } else {
          ApiMethods.UserApplySignController.viewUrl({
            applyNo: this.rowData.applyNo
          }).then(res => {
            this.nextViewUrlFn(res);
          });
        }

      }
    },
    //  多文件防伪打印 multiFile
    goMultiFilePrint (obj) {
      ApiMethods.SignPrintController.getSignMulti(obj)
        .then(res1 => {
          if (!res1.success)
            return this.$message.error(res1.description || "操作失败");
          ApiMethods.SignPrintController.printMultiStatus(
            Object.assign(res1.data, { userType: this.userType })
          )
            .then(res2 => {
              if (!res2.success)
                return this.$message.error(res2.description || "操作失败");
              if (res2.data.needPay) {
                this.$confirm(
                  `需消耗${res2.data.point}积分,支付成功后24小时内可重复打印，超出时间后将再次收费。`,
                  "支付提示",
                  {
                    showConfirmButton: true,
                    showCancelButton: true,
                    type: "info"
                  }
                ).then(() => {
                  ApiMethods.SignPrintController.orderMulti(
                    Object.assign(res1.data, {
                      userType: this.userType,
                      pay: 1
                    })
                  )
                    .then(res => {
                      if (+res.code === 10806) {
                        this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                        return;
                      }
                      if (+res.code === 0) {
                        let { href } = this.$router.resolve({
                          path: "/applySign/contractPrint",
                          query: this.$route.query
                        });
                        isInDingTalk ? location.href = location.origin + href : window.open(window.location.origin + href);
                        return;
                      }
                      this.$message.error(res.description || "支付失败");
                    })
                    .finally(() => { });
                });
              } else {
                let { href } = this.$router.resolve({
                  path: "/applySign/contractPrint",
                  query: this.$route.query
                });
                isInDingTalk ? location.href = location.origin + href : window.open(window.location.origin + href);
              }
            })
            .finally(() => { });
        })
        .finally(() => { });
    },
    //  单文件防伪打印 multiFile
    goPrint (obj) {
      ApiMethods.SignPrintController.getSign(obj)
        .then(res1 => {
          if (!res1.success)
            return this.$message.error(res1.description || "操作失败");
          ApiMethods.SignPrintController.printStatus(
            Object.assign(res1.data, { userType: this.userType })
          )
            .then(res2 => {
              if (!res2.success)
                return this.$message.error(res2.description || "操作失败");
              if (res2.data.needPay) {
                this.$confirm(
                  `需消耗${res2.data.point}积分,支付成功后24小时内可重复打印，超出时间后将再次收费。`,
                  "支付提示",
                  {
                    showConfirmButton: true,
                    showCancelButton: true,
                    type: "info"
                  }
                ).then(() => {
                  ApiMethods.SignPrintController.order(
                    Object.assign(res1.data, {
                      userType: this.userType,
                      pay: 1
                    })
                  )
                    .then(res => {
                      if (+res.code === 10806) {
                        this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                        return;
                      }
                      if (+res.code === 0) {
                        let { href } = this.$router.resolve({
                          path: "/applySign/contractPrint",
                          query: this.$route.query
                        });
                        isInDingTalk ? location.href = location.origin + href : window.open(window.location.origin + href);
                        return;
                      }
                      this.$message.error(res.description || "支付失败");
                    })
                    .finally(() => { });
                });
              } else {
                let { href } = this.$router.resolve({
                  path: "/applySign/contractPrint",
                  query: this.$route.query
                });
                isInDingTalk ? location.href = location.origin + href : window.open(window.location.origin + href);
              }
            })
            .finally(() => { });
        })
        .finally(() => { });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__header {
  border-radius: 0 !important;
  padding: 2px 10px;
}
.more_btn_box {
  // padding-left: 118px;
}
.operate_btn {
  margin: 0 10px;
  cursor: pointer;
  color: #290202;
  font-weight: bold;
  word-break: break-all;
  font-size: 14px;
  &:hover {
    color: #ec1c1c;
  }
}
.operate_ul {
  display: flex;
  justify-content: flex-start;
}
.demo-dynamic {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  /*padding: 20px 20px 10px;*/
}
.service_ul {
  padding: 0 10px;
  .service_li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .operation_btn {
      margin-left: 10px;
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .add_btn {
        cursor: pointer;
        font-size: 20px;
        color: #a0a0a0;
        border: 1px dashed #c0c0c0;
        border-radius: 2px;
        padding: 0 6px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
    .tip_text {
      height: 30px;
      line-height: 30px;
      padding: 0 12px;
      flex-shrink: 0;
      border-radius: 4px;
      background-color: #f59a23;
      color: #ffffff;
      font-size: 12px;
    }
    .tip_text1 {
      background-color: #ec1c1c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/more-button.vue